import { Grid, useTheme, useMediaQuery, Container, Box } from '@mui/material'
import { FooterIcon } from 'src/utils/Icon'
import { ExplanationImg, DownloadIcon } from './style'
import Text from '../Text'

interface IFooter {
  isAuthScreen: boolean
}

const Footer = ({ isAuthScreen }: IFooter) => {
  const theme = useTheme()
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'))
  const ExplanationImgURL = isSMDown ? FooterIcon.MobileExplanation : FooterIcon.PCExplanation

  return (
    <Container>
      <ExplanationImg src={ExplanationImgURL} alt="電力クーポンアプリ登場" />

      {isSMDown && (
        <Box mb={isAuthScreen ? 15 : 0}>
          <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
            <Grid item>
              <DownloadIcon alt="app store" src={FooterIcon.AppStore} />
            </Grid>

            <Grid item>
              <DownloadIcon alt="google play" src={FooterIcon.GooglePlay} />
            </Grid>
          </Grid>
        </Box>
      )}

      <Box mb={1}>
        <Text color="white" size={12} align="center">
          copyright&copy;2015&nbsp;M･E･M.Co.Ltd&nbsp;All&nbsp;Right&nbsp;Reserved.
        </Text>
      </Box>
    </Container>
  )
}

export default Footer
